import { Plugins } from '@capacitor/core';
import fb from '@/firebaseConfig';

const { Device } = Plugins;

// NOTE: Commented out browser device info for now, not needed for native apps

// import Bowser from 'bowser';

/*

  STATE

 */

const state = {
  isNativeApp: true, // Defaulting to true so native plugins run on startup
  isAndroidApp: false,
  isIOSApp: false,
  platform: '', // 'android', 'ios, 'web'
  os: '',
  osVersion: '',
  appVersion: '',
  appBuild: '',
  manufacturer: '',
  model: '',
  isDevProject: fb.isDevProject,
};

/*

  GETTERS

 */

const getters = {
  troubleshootingInfo(state, getters, rootState) {
    const { os, osVersion, appVersion, appBuild, manufacturer, model } = state;
    const osName = os === 'ios' ? 'iOS' : os.charAt(0).toUpperCase() + os.slice(1);
    const { email, uid } = rootState.user;
    return [
      `Email: ${email}`,
      `ID: ${uid}`,
      `App Version: ${appVersion} (${appBuild || 'n/a'})`,
      `OS: ${osName}`,
      `OS Version: ${osVersion}`,
      `Device: ${model} (${manufacturer})`,
    ].join('\n');
  },

  isAndroid: state => state.os === 'Android',
  isIOS: state => state.os === 'iOS',

  androidPackageName: state =>
    state.isDevProject ? 'app.imaginarie.app.dev' : 'app.imaginarie.app',
  iOSBundleId: state => (state.isDevProject ? 'app.imaginarie.app.dev' : 'app.imaginarie.app'),
  dynamicLinkDomain: state =>
    state.isDevProject ? 'dev.link.imaginarie.app' : 'link.imaginarie.app',
  // isOlderIOS: state => state.os === 'iOS' && state.osVersionNum < 12.2,
  // isIPad: state => state.platformModel.toLowerCase().includes('ipad'),
};

/*

  ACTIONS

 */

const actions = {
  init({ commit, dispatch }) {
    const { userAgent = '' } = window.navigator || {};

    const isNativeApp = userAgent.indexOf('capacitor') > -1;
    const isAndroidApp = userAgent.indexOf('capacitor-android') > -1;
    const isIOSApp = userAgent.indexOf('capacitor-ios') > -1;

    commit('setApp', { isNativeApp, isAndroidApp, isIOSApp });
    dispatch('getDeviceInfo');
  },

  async getDeviceInfo({ commit }) {
    try {
      const info = await Device.getInfo();
      // console.log(info);
      commit('setDeviceInfo', info);
    } catch (error) {
      console.error('Error getting device info', error);
    }
  },

  getBrowserInfo() {
    // const bowser = Bowser.getParser(userAgent);
    // info.bowser = bowser.getResult();
    // info.browserInfo = bowser.getBrowser() || {};
    // info.browser = info.browserInfo.name;
    // info.browserVersionNum = getVersionNum(info.browserInfo.version);
    // info.osInfo = bowser.getOS() || {};
    // info.os = info.osInfo.name;
    // info.osVersionNum = getVersionNum(info.osInfo.version);
    // info.platform = info.bowser.platform || {};
    // info.platformModel = info.platform.model || '';
    // info.shareSupported = navigator.share !== undefined;
    // info.swSupported = !!('serviceWorker' in navigator);
    // const getVersionNum = version => {
    //   if (!version || typeof version !== 'string') {
    //     return null;
    //   }
    //   const arr = version.split('.');
    //   return +`${arr[0] || 0}.${arr[1] || 0}`;
    // };
  },

  // detectStandaloneMode({ commit, dispatch }) {
  //   let isStandalone = false;
  //   if (
  //     window.matchMedia('(display-mode: fullscreen)').matches ||
  //     window.matchMedia('(display-mode: standalone)').matches ||
  //     window.navigator.standalone === true
  //   ) {
  //     isStandalone = true;
  //     commit('setStandaloneMode');
  //   }
  //   // dispatch('analytics/setDisplayMode', isStandalone, { root: true });
  // },
};

/*

  MUTATIONS

 */

const mutations = {
  setApp(state, { isNativeApp, isAndroidApp, isIOSApp }) {
    state.isNativeApp = isNativeApp;
    state.isAndroidApp = isAndroidApp;
    state.isIOSApp = isIOSApp;
  },

  setDeviceInfo(state, info) {
    state.platform = info.platform;
    state.os = info.operatingSystem;
    state.osVersion = info.osVersion;
    state.appBuild = info.appBuild;
    state.appVersion = info.appVersion;
    state.manufacturer = info.manufacturer;
    state.model = info.model;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
